var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle73A = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 80",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M7.5 6H42l.725 7.251A2.5 2.5 0 0 1 40.237 16H17.5a2.5 2.5 0 0 0-2.5 2.5v48.639a2.5 2.5 0 0 1-2.835 2.477L5 68.647V8.5A2.5 2.5 0 0 1 7.5 6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M5 70V8.5A2.5 2.5 0 0 1 7.5 6H43"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35.5 73a2.5 2.5 0 0 0 2.5-2.5v-49a2.5 2.5 0 0 0-2.5-2.5h-15a2.5 2.5 0 0 0-2.5 2.5v49a2.5 2.5 0 0 0 2.5 2.5h15ZM52 58v10l-8.274.752A2.5 2.5 0 0 1 41 66.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L52 58Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m50 57 .445.223A2.813 2.813 0 0 1 52 59.738v6.524c0 1.065-.602 2.039-1.555 2.515L50 69"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M52 22v10l-8.274.752A2.5 2.5 0 0 1 41 30.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L52 22Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m50 21 .445.223A2.813 2.813 0 0 1 52 23.738v6.524c0 1.065-.602 2.039-1.555 2.515L50 33"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M52 40v10l-8.274.752A2.5 2.5 0 0 1 41 48.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L52 40Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m50 39 .445.223A2.813 2.813 0 0 1 52 41.738v6.524c0 1.065-.602 2.039-1.555 2.515L50 51"
})));
SvgRectangle73A.viewBox = '0 0 60 80';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle73A);
export default ForwardRef;